import { QRCodeSVG }from 'qrcode.react';  // Add this import
import { LAMPORTS_PER_SOL } from '@solana/web3.js';

// Add this new function at the bottom of the file
export const SolanaQRCode = ({address, amount}) => {
  // SOL amount should be in lamports (1 SOL = 1,000,000,000 lamports)
  const solAmount = parseFloat(amount);
  const solanaURI = `solana:${address}?amount=${solAmount.toFixed(5)}`;

  return (
    <QRCodeSVG
      value={solanaURI}
      size={256}
      level="H"
      includeMargin={true}
      fgColor="#000000"
      bgColor="#ffffff"
    />
  );
};
